import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type ItemIconsProps = {
	nameIcon: React.ComponentProps<typeof MaterialCommunityIcons>["name"];
};

export const ItemIcons = ({ nameIcon }: ItemIconsProps) => {
	const theme = useAppTheme();
	return (
		<Box
			style={[
				{
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: theme.roundness * 3,
					width: 56,
					height: 56,
					borderWidth: 1,
					borderColor: theme.colors.outlineVariant,
					backgroundColor: theme.colors.secondaryContainer,
				},
			]}
		>
			<MaterialCommunityIcons
				name={nameIcon}
				size={36}
				color={theme.colors.onSecondaryContainer}
			/>
		</Box>
	);
};
